module.exports = __webpack_public_path__ + "static/media/loader.4c917636.gif";